import {Component, output} from "@angular/core";
import {MK_MOBILE_APP_HEADER, MobileAppHeaderController} from "../_controllers/mobile-app-header.controller";
import {MobileAppHeaderModel} from "../_models/MobileAppHeaderModel";

@Component({
  selector: 'link-mobile-app-header',
  templateUrl: './mobile-app-header.view.html',
  styleUrls: ['./mobile-app-header.view.scss'],
  providers: [
    MobileAppHeaderController,
  ]
})
export class MobileAppHeaderView {

  onActivation = output<any>();

  protected readonly model: MobileAppHeaderModel;

  constructor(private controller: MobileAppHeaderController) {

    this.model = controller.getModel(MK_MOBILE_APP_HEADER);
  }

  activateMenu() {
    this.onActivation.emit({});
  }
}
